export function convertToInt(numero) {
  if (numero % 1 === 0) {
    // Se a parte decimal for 0 (número inteiro), converte para inteiro
    numero = parseInt(numero);
    return numero;
  }
  return numero;
}
